import Theme from '../../enums/theme';

// all colors must be at the standard 6 characters, so they can use the CSS transparency feature.
//  #ffffff50 = white with 50% transparency.

export default {
  title: Theme.LIGHT,
  colors: {
    primary: '#CD1719',
    primaryLight: '#fa4c30',
    primaryMedium: '#cd1719',
    primaryDark: '#870000',

    secondary: '#c6184c',

    background: '#eee',
    backgroundLight: '#C0C0C0',
    surface: '#fdfdfd',

    text: '#555555',
    textLight: '#797979',

    positive: '#007777',
    negative: '#b00020',
    warning: '#8f7d37',

    onPrimary: '#ffffff',
    onWarning: '#333333',
    onSecondary: '#ffffff',
    onBackground: '#333333',
    onSurface: '#555555',
    onSurfaceLight: '#eaeaea',
  },
};
